import React from "react"
import Value from "aldoo-ra/Value"
import Button from "aldoo-ra/Button"
import { ChevronDownIcon } from "@heroicons/react/24/outline"
import useSigninController from "aldoo-ra/Signin/signin-controller"
import Menu from "aldoo-ra/Menu"

const UserProfileMenu = () => {
  const [userProfile] = Value("user-profile")
  const { logout } = useSigninController()

  // Handle sign in action
  const handleSignIn = () => {
    window.location.href = "/admin/sign-in"
  }

  // Menu data structure
  const menuData = {
    label: "User Options",
    items: [
      {
        label: "Profile Settings",
        options: { action: "profile.settings" },
        icon: (
          <svg
            className="w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 0 1 0-.255c.007-.378-.138-.75-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"
            />
          </svg>
        ),
      },
      {
        label: "Logout",
        options: { action: "user.logout" },
        icon: (
          <svg
            className="w-4 h-4"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9"
            />
          </svg>
        ),
      },
    ],
  }

  // Action map to handle menu item clicks
  const actionMap = {
    "user.logout": () => {
      logout()
    },
    "profile.settings": () => {
      window.location.href = "/account?section=profile"
    },
  }

  // If no user is logged in, show sign in button
  if (!userProfile) {
    return (
      <Button
        variant="admin_primary"
        onClick={handleSignIn}
        className="absolute top-8 right-8"
      >
        Sign In
      </Button>
    )
  }

  // Menu item renderer
  const renderMenuItem = (item) => {
    return (
      <div className="flex flex-row items-center gap-2 p-2">
        {item.icon}
        <span>{item.label}</span>
      </div>
    )
  }

  return (
    <div>
      <Menu
        menuData={menuData}
        actionMap={actionMap}
        renderAs="vlist.menu"
        itemWidth="200px"
        submenuMode="vertical"
        hideOnItemClick={true}
        hoverMode={true}
        menuAlign="right"
        styleOverrides={{
          menu_item: "hover:bg-transparent flex flex-col p-0 m-0 items-left justify-between rounded-md cursor-pointer text-admin_text hover:text-admin_primary",
        }}
        rootItemRender={(item) => (
          <Button
            variant="admin_secondary"
            className="flex items-center justify-center gap-2 px-4"
          >
            <span>{userProfile.name}</span>
            <ChevronDownIcon className="w-4 h-4" strokeWidth={2} />
          </Button>
        )}
        menuItemRender={renderMenuItem}
      />
    </div>
  )
}

export default UserProfileMenu
